import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA, PER_PAGE } from '@/plugins/vuex-async-pagginate';

class NumberServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getForEntryPoint(params = {}) {
    return this.pure_http.get(`/pbx/client/numbers/entry-points`, { params });
  }

  getTableList(params = {}) {
    return this.pure_http.get(`/pbx/client/numbers`, { params });
  }

  getSelect(params = {}) {
    return this.pure_http.get(`/pbx/client/select/numbers`, { params });
  }

  getForScheme(params = {}) {
    return this.http.get('', { params: { [PER_PAGE]: 500, ...params } }).then(res => res[DATA]);
  }

  createItem(number, type, client_id = '') {
    return this.http.post('', { number, type, client_id });
  }

  createExternal(number, id) {
    return this.createItem(number, 'external', id);
  }

  createInternal(number, id) {
    return this.createItem(number, 'internal', id);
  }
}

export const NumberService = new NumberServiceClass({
  api_version: 2,
  resource: 'pbx/numbers'
});
